


































import { Component, Vue, Prop } from "vue-property-decorator";
import { withDrawList, numwithList } from "./dataConfig";
@Component({
  components: {},
})
export default class Home extends Vue {
  public dataList = withDrawList;
  public isShow = false;
  public numList: any = numwithList;
  public parentList(nowData, isShow, pastData) {
    this.numList = [];
    nowData.forEach((item, index) => {
      // console.log(item);
      // console.log(pastData[index]);
      this.numList.push({
        curr_num: item,
        past_num: pastData[index],
        radio_show: isShow ? this.returnIconShow(item, pastData[index]) : false,
        contrast_radio: !isShow
          ? 0
          : this.returnIconShow(item, pastData[index])
          ? this.returnIconRadio(item, pastData[index])
          : 0,
      });
    });
    setTimeout(() => {
      this.isShow = isShow;
    }, 0);
  }
  public returnIconShow(nowNum, pastNum) {
    if (nowNum == 0 || pastNum == 0 || nowNum == pastNum) {
      return false;
    } else {
      return true;
    }
  }
  public returnIconRadio(nowNum, pastNum) {
    const numa = pastNum - nowNum;
    const numb = numa / nowNum;
    const numc = numb * 100;
    return numc.toFixed(2);
  }
}
